import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { useMenuStyles } from "../../components/menuStyles";

// "Configurações do fluxo" (Etapa 4 do handoff MCP). O único controle do usuário
// aqui é a POSSE: liberar (ou não) a IA a editar este fluxo via MCP. Editar
// inclui APAGAR — por isso o aviso na tela ao ligar (decisão do dono).
//
// O estado "em desenvolvimento" NÃO é toggle: é uma flag que a PRÓPRIA IA
// gerencia (via MCP) para sinalizar que o fluxo ainda não é produção. O usuário
// só a vê (badge na lista / chip no header), não a liga/desliga aqui.
const FlowSettingsModal = ({ open, aiEditable, onClose, onSave }) => {
  const menu = useMenuStyles();
  const [ai, setAi] = useState(!!aiEditable);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (open) setAi(!!aiEditable);
  }, [open, aiEditable]);

  const salvar = async () => {
    setSalvando(true);
    try {
      await onSave({ aiEditable: ai });
      onClose();
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={salvando ? undefined : onClose} maxWidth="sm" fullWidth PaperProps={{ className: menu.dialogPaper }}>
      <DialogTitle>Configurações do fluxo</DialogTitle>
      <DialogContent dividers>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <FormControlLabel
            control={<Switch checked={ai} onChange={e => setAi(e.target.checked)} color="primary" />}
            label="Permitir edição via MCP"
          />
          <div style={{ fontSize: 13, color: "#6b6b6b", marginLeft: 46, marginTop: -4 }}>
            Permite que a IA (via MCP) altere este fluxo. Fluxos criados pela própria IA já vêm liberados.
          </div>
          {ai && (
            <div
              style={{
                marginLeft: 46,
                marginTop: 8,
                padding: "8px 12px",
                borderRadius: 8,
                background: "rgba(177,42,42,0.08)",
                color: "#B12A2A",
                fontSize: 13,
                lineHeight: 1.4,
              }}
            >
              Atenção: editar inclui <strong>apagar</strong>. Ligado, a IA pode alterar e excluir este fluxo.
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={salvando}>Cancelar</Button>
        <Button onClick={salvar} color="primary" variant="contained" disabled={salvando}>
          {salvando ? "Salvando…" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowSettingsModal;
